import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueRouterPrefetch from 'vue-router-prefetch'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import i18n from './i18n'
import lang from 'element-ui/lib/locale/lang/en'
import langHr from 'element-ui/lib/locale/lang/hr'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import conf from './config.js'

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import initProgress from './progressbar';
import axiosWrapper from 'src/util/axiosWrapper.js';

// include store as global Vue property
import store from './store';
Vue.prototype.$store = store;


// router setup
import routes from './routes/routes'

// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/demo.scss'
import './assets/sass/flota.scss'

import sidebarLinks from './sidebarLinks'
//import './registerServiceWorker'

// plugin setup
Vue.use(VueRouter)
Vue.use(VueRouterPrefetch)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate)
Vue.use(axiosWrapper);
locale.use(lang)


// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to) => {
	if (to.hash) {
		return {selector: to.hash}
	}
		else {
		return { x: 0, y: 0 }
	}
  }
})

router.beforeEach(async (to, from, next) => {
  // console.log('conf== ', conf);
  if (conf.isLocal && conf.apiAuthOff) {
	  store.user.data = require('./user.json');
    i18n.locale = store.user.data.language;
    locale.use(langHr);
  }
  if (to.path === '/login') return next()
  if (store.user && store.user.data) return next()

  //console.log('no profile data, need to check profile before going to ', to.path);
  let result;
  let error;
  try {
	  result = await Vue.axios.get("ui/profile");
  }
  catch(err) {
	  error = err && err.response && err.response.data
  }
  if (result) {
	store.user.data = result;
    i18n.locale = store.user.data.language
    if (i18n.locale && i18n.locale === 'hr') locale.use(langHr);
	return next();
  }
  else {
	console.log('not logged in, forward to login', error || result);
	store.user.data = null;
	router.push('/login');
  }
})


initProgress(router);


/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  store,
  render: h => h(App),
  router
})
